// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import NutUI from '@nutui/nutui'
import '@nutui/nutui/dist/nutui.css'
import '@/assets/scss/common.scss'

// 公共组件
import SearchNavbar from '@/components/Navbars/searchNavbar'
import TitleNavbar from '@/components/Navbars/titleNavbar'
import MySwiper from '@/components/MySwiper/index'
import Goods from '@/components/Goods'
import common from '@/utils/commonFunctions'
import smartParse from 'vue-smart-parse'
Vue.use(smartParse)
Vue.component('search-navbar', SearchNavbar)
Vue.component('title-navbar', TitleNavbar)
Vue.component('goods', Goods)
Vue.component('my-swiper', MySwiper)


NutUI.install(Vue)
Vue.prototype.common = common // 公共函数
Vue.config.productionTip = false

/*
 * 定义常量
 */
let DOMAIN_URL = ''
let ADMIN_URL = ''
/**
 * 开发环境和发布环境变量
 */
if (process.env.NODE_ENV === 'development') {
  //DOMAIN_URL = 'http://guoyonghao.imwork.net/'
  DOMAIN_URL = 'http://market.h5.cnxieku.com/'
  //DOMAIN_URL = 'https://16m022h777.oicp.vip/'
  ADMIN_URL = 'http://supplier.cnxieku.com'
  console.log('开发环境')
} else {
  DOMAIN_URL = 'http://market.h5.cnxieku.com/'
  ADMIN_URL = 'http://supplier.cnxieku.com'
  console.log('发布环境')
}
Vue.prototype.DOMAIN_URL = DOMAIN_URL
Vue.prototype.ADMIN_URL = ADMIN_URL

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js